import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Content = styled.div`
  #box {
    height: 150px;
    background: #ffffff;
    display: flex;
    border: 5px solid #f1f1f1;
    width: 67%;
    flex-direction: column;
    padding: 20px;
    
    #button {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

    #Button {
      height: 70%;
      width: 50%;
      width: min-content;
    }

  }
    #textBox {
      height: 63px;
      width: 100%;
      display: flex;
      background: #ffffff;
      
  
      #escreve {
          box-sizing: border-box;
          width: 100%;
          border: 3px solid #f1f1f1;
  
      }
    }
  }  
`;
